import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { BootstrapVue, VBScrollspyPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import Vuelidate from "vuelidate";
var VueScrollTo = require("vue-scrollto");
import VueScrollactive from "vue-scrollactive";

Vue.use(VueScrollactive);
Vue.use(VueScrollTo);
Vue.use(Vuelidate);
Vue.use(BootstrapVue);
Vue.use(VBScrollspyPlugin);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
